import { useEffect } from "react";
import { FaChevronRight, FaTimes } from "react-icons/fa";
import styles from "./Navbar.module.scss";
import classNames from "classnames";
import { Message } from "@messageformat/react";

const MenuButton = ({ icon: Icon, href, title, subtitle, open, ...props }) => {
  return (
    <a
      href={href}
      className={classNames(styles.menuButton, open && styles.menuButtonOpen)}
      {...props}
    >
      <div className={styles.menuIcon}>
        <Icon />
      </div>
      <div className={styles.menuText}>
        <div className={styles.menuTextTitle}>{title}</div>
        <div className={styles.menuTextSubtitle}>{subtitle}</div>
      </div>
    </a>
  );
};

const MasonryCard = ({
  open,
  index,
  data: { href, title, description },
  width,
}) => (
  <MenuButton
    key={index}
    href={href}
    open={open}
    title={<Message id={title} />}
    subtitle={<Message id={description} />}
    icon={FaChevronRight}
    style={{ width: width, transitionDelay: `${index * 0.1}s` }}
  />
);

const items = [
  {
    href: "/chmurowy-system-zarzadzania-sprzedaza",
    title: "navbar.menu.cloud",
    description: "navbar.menu.descriptions.cloud",
  },
  {
    href: "/kioski-samoobslugowe-z-chatem-gpt",
    title: "navbar.menu.kiosks",
    description: "navbar.menu.descriptions.kiosks",
  },
  {
    href: "/ai-w-twoim-punkcie-sprzedazy",
    title: "navbar.menu.rapidshopAI",
    description: "navbar.menu.descriptions.rapidshopAI",
  },
  {
    href: "/aplikacja-sprzedazowa-android",
    title: "navbar.menu.pos",
    description: "navbar.menu.descriptions.pos",
  },
  {
    href: "/system-ekranow-kuchennych",
    title: "navbar.menu.kds",
    description: "navbar.menu.descriptions.kds",
  },
  {
    href: "/system-promocji-i-rabatow",
    title: "navbar.menu.discounts",
    description: "navbar.menu.descriptions.discounts",
  },
  {
    href: "/latwe-zarzadzanie-sprzetem",
    title: "navbar.menu.management",
    description: "navbar.menu.descriptions.management",
  },
];

// Simple custom masonry layout that doesn't depend on scroll
const SimpleMasonry = ({
  items,
  render,
  columnCount = 2,
  columnGutter = 40,
  rowGutter = 20,
}) => {
  const columns = Array.from({ length: columnCount }, () => []);

  // Distribute items across columns
  items.forEach((item, index) => {
    const columnIndex = index % columnCount;
    columns[columnIndex].push({ ...item, index });
  });

  return (
    <div
      style={{
        display: "flex",
        gap: `${columnGutter}px`,
        width: "100%",
        alignItems: "flex-start",
      }}
    >
      {columns.map((column, columnIndex) => (
        <div
          key={columnIndex}
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: `${rowGutter}px`,
            maxWidth: "400px",
          }}
        >
          {column.map((item) =>
            render({
              data: item,
              index: item.index,
              width: "100%",
            })
          )}
        </div>
      ))}
    </div>
  );
};

const Possibilities = ({ isMainPage, open, onClose }) => {
  useEffect(() => {
    if (open) {
      window.document.documentElement.style.overflow = "hidden";
    } else {
      window.document.documentElement.style.overflow = "auto";
    }
  }, [open]);

  return (
    <>
      {open && (
        <div className={styles.menuOverlay} onClick={() => onClose()}></div>
      )}
      <div
        className={styles.menuWrapper}
        style={{
          pointerEvents: open ? "auto" : "none",
          zIndex: 2000,
          top: 0,
          left: 0,
        }}
      >
        <div className={styles.menu}>
          {open && (
            <button
              onClick={() => onClose()}
              style={{
                position: "absolute",
                top: 0,
                right: 20,
                zIndex: 3000,
                background: "transparent",
                border: "none",
              }}
            >
              <FaTimes size={30} color="#FFF" />
            </button>
          )}
          <SimpleMasonry
            items={items}
            render={(props) => <MasonryCard open={open} {...props} />}
            columnGutter={40}
            rowGutter={20}
            columnCount={2}
          />
        </div>
      </div>
    </>
  );
};

export default Possibilities;
